import registrationQuestionaryDictionary from '@features/registration-questionary/i18n/ru/registration-questionary.dic.json';

export const registrationQuestionary = {
  REGISTRATION_QUESTIONARY: registrationQuestionaryDictionary,
};

export const registrationQuestionaryNamespaces = Object.keys(
  registrationQuestionary
);
